var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader--text"},[_vm._v(_vm._s(_vm.loadingText))]),_c('div',{staticClass:"dots"}),_c('div',{staticClass:"dots"}),_c('div',{staticClass:"dots"})])}
var staticRenderFns = []

export { render, staticRenderFns }